
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'device-replace-v3-index',
})
